import React, { useContext, useEffect } from "react";
import { useNavigationBar } from "../../context/NavigationContext";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useNavigate } from "react-router-dom";
import ChannelCheckListCard from "./create/components/ChannelCheckListCard";
import { useAuth } from "../../context/AuthContext";

const Settings = () => {
  const authContext = useAuth();
  const { setNavProps, navProps } = useNavigationBar();
  const navigate = useNavigate();
  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Settings",
      subtitle: authContext?.currentUser?.displayName || "Channel",
      buttonTitle: "",
      filterOption: false,
      enableLink: false,
    });
  }, [setNavProps, navigate]);

  const { backArrow, title, subtitle, buttonTitle, enableLink, filterOption } =
    navProps;

  return (
    <>
      <ContainerNavigation
        backArrow={backArrow}
        title={title}
        subtitle={subtitle}
        enableLink={enableLink}
        buttonTitle={buttonTitle}
        filterOption={filterOption}
      />
      <div className="flex flex-col gap-[30px] mt-[30px] bg-white ">
        <ChannelCheckListCard
          name="Enrollment Fee"
          title="Enrollment Fee"
          purposeText="View Payment Receipt"
          doneText={"Paid"}
          isTitleMargin={true}
          action={() => {
            navigate("");
          }}
        />
        <ChannelCheckListCard
          name="Identify Verification"
          title="Identify Verification"
          purposeText="View ID Details"
          doneText={"Verified"}
          isTitleMargin={true}
          action={() => {
            navigate("");
          }}
        />
        <ChannelCheckListCard
          name="Application"
          title="Application"
          purposeText="View Application"
          doneText={"Approved"}
          isTitleMargin={true}
          action={() => {
            navigate("");
          }}
        />
        <ChannelCheckListCard
          name="Agreements"
          title="Agreements"
          purposeText="View Agreements"
          doneText={"Signed"}
          isTitleMargin={true}
          action={() => {
            navigate("");
          }}
        />
        <ChannelCheckListCard
          name="Pro Subscription"
          title="Pro Subscription"
          purposeText="Manage Subscription"
          doneText={"Active"}
          isTitleMargin={true}
          action={() => {
            navigate("");
          }}
        />
      </div>
    </>
  );
  //
};

export default Settings;
